export enum ExperimentSpec {
  // canary flag for studio guys in public media
  PublicMediaScoringProfile = 'specs.media-manager-g6.PublicMediaScoringProfile',
  FullStory = 'specs.media-manager-g6.FullStory',
  // internal to find wix employees
  PublicMediaWixOnly = 'specs.media-manager-g6.PublicMediaWixOnly',
  CantBuyOnShutterstock = 'specs.media-manager-g6.CantBuyOnShutterstock',
  // for editor media panel
  NewCheckout = 'specs.media-manager-g6.NewCheckout',
  NTT = 'specs.media-manager-g6.internal.NTT',
  ShowKeys = 'specs.media-manager-g6.internal.ShowKeys',
  OnlyFavsBoard = 'specs.media-manager-g6.internal.OnlyFavsBoard',
  PreventFontsUpload = 'specs.media-manager-g6.PreventFontsUploads',
  ForceUploadErrors = 'specs.media-manager-g6.internal.ForceUploadErrors',
  // when true dealer Lightbox wont pop up open just for specific user guides. made for automation/QA purpose only
  ExcludeDealerLightbox = 'specs.dealerClient.ExcludeDealerLightbox',
  DisableUpload = 'specs.media-manager-g6.DisableUpload',
  LinkToPublicCMS = 'specs.media-manager-g6.LinkToPublicCMS',
  Yell = 'specs.media-manager-g6.Yell',
  ForceYell = 'specs.media-manager-g6.ForceYell',
  StorageQuotaVisibilityAndEnforcement = 'specs.media-manager-g6.StorageQuotaVisibilityAndEnforcement',
  ManageStorageButton = 'specs.media-manager-g6.ManageStorageButton',
  AiTextToImage = 'specs.mdst.AiTextToImage',
  TrackOffline = 'specs.media-manager-g6.TrackOffline',
  UIAlignments = 'specs.media-manager-g6.UIAlignments',
  StorageQuotaGracePeriod = 'specs.media-manager-g6.StorageQuotaGracePeriod',
  LimitMimeTypes = 'specs.media-manager-g6.LimitMimeTypes',
  FileAwareness = 'spec.media-manager-g6.FileAwareness',
  PlatformizationTypesCheck = 'specs.media-manager-g6.PlatformizationTypesCheck',
  UsePlatformizedApi = 'specs.media-manager-g6.UsePlatformizedApi',
  HideInstagram = 'specs.media-manager-g6.HideInstagram',
  HideFlickr = 'specs.media-manager-g6.HideFlickr',
  UseSmallerLimitForPublicSearch = 'specs.media-manager-g6.NewSearchLimits',
  HideGooglePhotos = 'specs.media-manager-g6.HideGooglePhotos',
  IgnoreEmptyRoute = 'specs.media-manager-g6.IgnoreEmptyRoute',
  HideAdobeExpress = 'specs.media-manager-g6.HideAdobeExpress',
  WixSession3 = 'specs.media-manager-g6.WixSession3',
  CopyWixUrl = 'specs.media-manager-g6.CopyWixUrl',
  UseNewHelpWidget = 'specs.media-manager-g6.useNewHelpWidget',
  ForceWixelImport = 'specs.media-manager-g6.forceWixelImport',
}
